import Actions from './channel-actions';
import Api from './channel-api';
import Collection from './channel-collection';
import Model from './channel-model';
import reducer from './channel-reducer';
import sagas from './channel-sagas';
import Selectors from './channel-selectors';

export default {
  Actions,
  Api,
  Collection,
  Model,
  name:       'channel',
  namespace:  'channel',
  pluralName: 'channels',
  reducer,
  sagas:      [sagas],
  Selectors,
};
